export default {
  ["isConnecting"](state) {
    return state.connecting;
  },
  ["isReconnecting"](state) {
    return state.reconnecting;
  },
  ["isConnected"](state) {
    return state.connected;
  },
  ["denied"](state) {
    return state.denied;
  },
  ["connectionWatch"](state) {
    return state.connectionWatch;
  },
  ["user"](state) {
    return state.user;
  }
};
